import {CrudModel} from '@ngx-ivengi/crud';

export class Exportation  extends CrudModel {

  public id: string;
  public status: string;
  public userId: string;
  public mimeType: string;
  public path: string;

  public setStatus(status: string): Exportation {
    if(typeof status === 'string') {
      this.status = status;
    }
    return this;
  }

  public setUserId(userId: string): Exportation {
    if(typeof userId === 'string') {
      this.userId = userId;
    }
    return this;
  }

  public setMimeType(mimeType: string): Exportation {
    if(typeof mimeType === 'string') {
      this.mimeType = mimeType;
    }
    return this;
  }

  public setPath(path: string): Exportation {
    if(typeof path === 'string') {
      this.path = path;
    }
    return this;
  }

  public fromResponse(response: any): void {
    this
      .setId(response.id)
      .setStatus(response.status)
      .setUserId(response.userId)
      .setMimeType(response.mimeType)
      .setPath(response.path);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/exportation/exportation.model.ts